import React, { Component } from "react";
import { StudioSectionHeader, StudioFoldControl } from "./InstagramUnifiedStudioParts";
import ReactDOM from "react-dom";
import http from "../modules/api";
import InstagramTemplateEditor from "./InstagramTemplateEditor";
import ModalSizeSelect from "./component/ModalSizeSelect";
import TitleContentDialogV2 from "../modules/dialogs/TitleContentDialogV2";

const DEFAULT_RECOMMEND_TEMPLATES = [
  {
    title: "이벤트/프로모션",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_230330/07107.png",
    event_type_cd: "07107",
    alt: "추천 템플릿 1",
  },
  {
    title: "신상품 런칭",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_230424/07111.png",
    event_type_cd: "07111",
    alt: "추천 템플릿 2",
  },
  {
    title: "리뷰/베스트",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_220914/07000/07079.png",
    event_type_cd: "07079",
    alt: "추천 템플릿 3",
  },
  {
    title: "정보성(카드뉴스)",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_211214/07050.png",
    event_type_cd: "07050",
    alt: "추천 템플릿 4",
  },
  {
    title: "시즌 기획전",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_220714/07073.png",
    event_type_cd: "07073",
    alt: "추천 템플릿 5",
  },
  {
    title: "할인 쿠폰",
    imageUrl: "https://s3.ap-northeast-2.amazonaws.com/otdeal.file/banner_sample_260122/07161.png",
    event_type_cd: "07161",
    alt: "추천 템플릿 6",
  },
];

const getTemplateUpperCodeCdByEventTypeCd = (eventTypeCd) => {
  if (String(eventTypeCd || "").startsWith("07")) return "07000";
  if (String(eventTypeCd || "").startsWith("03")) return "03000";
  return "";
};

const getTemplateRatioByEventTypeCd = (eventTypeCd) => {
  if (String(eventTypeCd || "").startsWith("07")) return "4/5";
  if (String(eventTypeCd || "").startsWith("03")) return "16/9";
  return "1/1";
};

const convertRatioToEditorRatio = (ratio) => {
  return String(ratio || "1/1").replace("/", ":");
};

const getTemplateEventTypeCdByImageUrl = (imageUrl) => {
  const match = String(imageUrl || "").match(/\/([0-9]{5})\.(png|jpg|jpeg|webp)(\?.*)?$/i);
  return match ? match[1] : "";
};

const TEMPLATE_EVENT_HISTORY_API = "/rest/shop/instagram/InstagramTemplateEventHistory";
const TEMPLATE_EVENT_HISTORY_HIDE_API = "/rest/shop/instagram/InstagramTemplateEventHistory/hide";
const TEMPLATE_EVENT_HISTORY_PAGE_SIZE = 24;
const INSTAGRAM_CREATE_POST_URL = "/shop/instagram/InstagramCreatePost";
const STARTER_APPLY_TEMPLATE_STORAGE_KEY = "instagram_ai_design_starter_apply_template";
const DEFAULT_CREATE_TEMPLATE_RATIO = "4/5";

const getTemplateUpperCodeCdByRatio = (ratio) => {
  if (ratio === "16/9") return "03000";
  return "07000";
};

class InstagramAiDesignList extends Component {
  constructor(props) {
    super(props);
    this.templateEventHistoryLoading = false;
    this.pendingTemplateEventHistoryReset = false;
    this.scrollTimer = null;

    this.state = {
      show_design_template_popup: false,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
      currentRatio: "1/1",
      selectedDesign: null,
      designList: [],
      totalCnt: 0,
      designListLoading: false,
      hasMoreDesignList: true,
       recommendExpanded: false,
       galleryExpanded: false,
      isSizeModalOpen: false,
    };

    this.handleCreateDesign = this.handleCreateDesign.bind(this);
    this.handleUseTemplate = this.handleUseTemplate.bind(this);
    this.handleEditDesign = this.handleEditDesign.bind(this);
    this.handleInstagramRegister = this.handleInstagramRegister.bind(this);
    this.handleDownloadDesign = this.handleDownloadDesign.bind(this);
    this.handleDeleteDesign = this.handleDeleteDesign.bind(this);
    this.handleCloseTemplateEditor = this.handleCloseTemplateEditor.bind(this);
    this.applydDesign = this.applydDesign.bind(this);
    this.loadEventHistory = this.loadEventHistory.bind(this);
    this.handleWindowScroll = this.handleWindowScroll.bind(this);
    this.checkNeedLoadMore = this.checkNeedLoadMore.bind(this);
    this.openNewDesignEditorByRatio = this.openNewDesignEditorByRatio.bind(this);
  }

  componentDidMount() {
    this.loadEventHistory(true);
    window.addEventListener("scroll", this.handleWindowScroll);
  }

  componentWillUnmount() {
    window.removeEventListener("scroll", this.handleWindowScroll);

    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
      this.scrollTimer = null;
    }
  }

  handleWindowScroll() {
    if (this.scrollTimer) {
      clearTimeout(this.scrollTimer);
    }

    this.scrollTimer = setTimeout(this.checkNeedLoadMore, 120);
  }

  checkNeedLoadMore() {
    if ((this.props.embedded && (!this.props.active || !this.state.galleryExpanded)) || this.templateEventHistoryLoading || !this.state.hasMoreDesignList) {
      return;
    }

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0;
    const viewportHeight = window.innerHeight || document.documentElement.clientHeight || 0;
    const documentHeight = Math.max(
      document.body.scrollHeight,
      document.documentElement.scrollHeight,
      document.body.offsetHeight,
      document.documentElement.offsetHeight,
      document.body.clientHeight,
      document.documentElement.clientHeight
    );

    const scrollBottom = scrollTop + viewportHeight;
    const triggerPoint = documentHeight - (viewportHeight * 1.5);

    if (scrollBottom >= triggerPoint) {
      this.loadEventHistory(false);
    }
  }

  mergeDesignList(prevList, nextList) {
    const mergedList = [];
    const existsMap = {};

    (prevList || []).concat(nextList || []).forEach((item, index) => {
      const key = String(item.event_seq || item.media_source_id || item.source_url || index);

      if (existsMap[key]) {
        return;
      }

      existsMap[key] = true;
      mergedList.push(item);
    });

    return mergedList;
  }

  loadEventHistory(reset) {
    if (this.templateEventHistoryLoading) {
      if (reset) {
        this.pendingTemplateEventHistoryReset = true;
      }
      return;
    }

    if (!reset && !this.state.hasMoreDesignList) {
      return;
    }

    const url = this.props.templateEventHistoryUrl || TEMPLATE_EVENT_HISTORY_API;
    const rowcnt = this.props.templateEventHistoryRowCnt || TEMPLATE_EVENT_HISTORY_PAGE_SIZE;
    const startidx = reset ? 0 : this.state.designList.length;

    this.templateEventHistoryLoading = true;
    this.setState({ designListLoading: true });

    http.get(url, {
      params: {
        startidx: startidx,
        rowcnt: rowcnt,
        start: startidx,
        row_cnt: rowcnt,
      }
    })
      .then((res) => {
        const data = res && res.data ? res.data : {};
        const list = Array.isArray(data.list) ? data.list : [];
        const totalCnt = Number(data.totalCnt || data.total_cnt || 0);
        const nextDesignList = reset ? list : this.mergeDesignList(this.state.designList, list);
        const hasMoreDesignList = totalCnt > 0 ? nextDesignList.length < totalCnt : list.length >= rowcnt;

        this.templateEventHistoryLoading = false;

        this.setState({
          designList: nextDesignList,
          totalCnt: totalCnt || nextDesignList.length,
          designListLoading: false,
          hasMoreDesignList: hasMoreDesignList,
        }, () => {
          if (this.pendingTemplateEventHistoryReset) {
            this.pendingTemplateEventHistoryReset = false;
            this.loadEventHistory(true);
          } else {
            setTimeout(this.checkNeedLoadMore, 150);
          }
        });
      })
      .catch((e) => {
        console.error("InstagramTemplateEventHistory API 호출 실패:", e);
        this.templateEventHistoryLoading = false;

        this.setState({
          designList: reset ? [] : this.state.designList,
          totalCnt: reset ? 0 : this.state.totalCnt,
          designListLoading: false,
          hasMoreDesignList: false,
        }, () => {
          if (this.pendingTemplateEventHistoryReset) {
            this.pendingTemplateEventHistoryReset = false;
            this.loadEventHistory(true);
          }
        });
      });
  }

  async checkInstagramFreePeriod() {
    try {
      const res = await http.get("/rest/shop/instagram/FreePreriod");
      const isFinish = res && res.data ? Number(res.data.is_finish) : null;

      if (isFinish === 1) {
        window.alert("이용 기간이 종료되었습니다.");
        return false;
      }

      return true;
    } catch (error) {
      console.error("인스타그램 이용 기간 확인 실패:", error);
      return true;
    }
  }

  async handleCreateDesign(e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    this.setState({
      isSizeModalOpen: true,
    });

    if (typeof this.props.onCreateDesign === "function") {
      this.props.onCreateDesign(e);
    }
  }

  async openNewDesignEditorByRatio(ratio) {
    if (!(await this.checkInstagramFreePeriod())) {
      this.setState({ isSizeModalOpen: false });
      return;
    }

    const imageRatio = ratio || this.props.defaultCreateTemplateRatio || DEFAULT_CREATE_TEMPLATE_RATIO;

    this.setState({
      isSizeModalOpen: false,
      show_design_template_popup: true,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: getTemplateUpperCodeCdByRatio(imageRatio),
      currentRatio: imageRatio,
      selectedDesign: null,
    });
  }

  async handleUseTemplate(template, e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    const eventTypeCd = this.getDesignEventTypeCd(template);
    const imageRatio = this.getDesignImageRatio(template);

    this.setState({
      show_design_template_popup: true,
      selected_event_seq: "",
      selected_template_event_type_cd: eventTypeCd,
      selected_template_upper_code_cd: template.upper_code_cd || template.upperCodeCd || getTemplateUpperCodeCdByEventTypeCd(eventTypeCd),
      currentRatio: imageRatio,
      selectedDesign: null,
    });
  }

  async handleEditDesign(design, e) {
    if (e) {
      e.stopPropagation();
    }

    if (!(await this.checkInstagramFreePeriod())) {
      return;
    }

    const eventTypeCd = this.getDesignEventTypeCd(design);
    const imageRatio = this.getDesignImageRatio(design);

    this.setState({
      show_design_template_popup: true,
      selected_event_seq: design.event_seq || design.eventSeq || "",
      selected_template_event_type_cd: eventTypeCd,
      selected_template_upper_code_cd: design.upper_code_cd || design.upperCodeCd || getTemplateUpperCodeCdByEventTypeCd(eventTypeCd),
      currentRatio: imageRatio,
      selectedDesign: design,
    });

    if (typeof this.props.onEditDesign === "function") {
      this.props.onEditDesign(design, e);
    }
  }

  handleInstagramRegister(design, e) {
    if (e) {
      e.stopPropagation();
    }

    this.moveToCreatePostWithDesign(design);

    if (typeof this.props.onInstagramRegister === "function") {
      this.props.onInstagramRegister(design, e);
    }
  }

  async handleDownloadDesign(design, e) {
    if (e) {
      e.stopPropagation();
    }

    const imageUrl = this.getDesignImageUrl(design);

    if (!imageUrl) {
      window.alert("다운로드할 이미지가 없습니다.");
      return;
    }

    try {
      const response = await fetch(imageUrl);

      if (!response.ok) {
        throw new Error("이미지 다운로드 요청 실패");
      }

      const blob = await response.blob();
      const blobUrl = window.URL.createObjectURL(blob);
      const link = document.createElement("a");

      link.href = blobUrl;
      link.download = this.getDownloadFileName(design, imageUrl);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(blobUrl);
    } catch (error) {
      console.error("디자인 이미지 다운로드 실패:", error);
      this.downloadImageByLink(imageUrl, this.getDownloadFileName(design, imageUrl));
    }

    if (typeof this.props.onDownloadDesign === "function") {
      this.props.onDownloadDesign(design, e);
    }
  }

  openConfirmDialog(props) {
    return new Promise((resolve) => {
      const container = document.createElement("div");
      document.body.appendChild(container);

      const close = (result) => {
        resolve(result);
        ReactDOM.unmountComponentAtNode(container);
        container.remove();
      };

      ReactDOM.render(
        <TitleContentDialogV2
          {...props}
          popup_close={() => close(false)}
          button_list={[
            {
              title: "확인",
              event_method: () => close(true),
            },
            {
              title: "취소",
              event_method: () => close(false),
            },
          ]}
        />,
        container
      );
    });
  }

  async handleDeleteDesign(design, e) {
    if (e) {
      e.stopPropagation();
    }

    const eventSeq = this.getDesignEventSeq(design);

    if (!eventSeq) {
      window.alert("삭제할 디자인 정보를 찾을 수 없습니다.");
      return;
    }

    const result = await this.openConfirmDialog({
      title: "이 디자인을 삭제하시겠습니까?",
      content: "삭제한 디자인은 마이 디자인 갤러리에서 보이지 않습니다.",
    });

    if (!result) {
      return;
    }

    http.post(TEMPLATE_EVENT_HISTORY_HIDE_API, {
      event_seq: eventSeq,
    }, {
      headers: { "Content-Type": "application/json" },
    })
      .then(() => {
        this.setState((prevState) => ({
          designList: (prevState.designList || []).filter((item) => String(this.getDesignEventSeq(item)) !== String(eventSeq)),
          totalCnt: Math.max((prevState.totalCnt || 0) - 1, 0),
        }), () => this.loadEventHistory(true));
      })
      .catch((error) => {
        console.error("디자인 갤러리 삭제 실패:", error);
        window.alert("디자인 삭제에 실패했습니다.");
      });
  }

  getDesignMediaSourceId(design) {
    return design.media_source_id || design.mediaSourceId || "";
  }

  getDesignEventSeq(design) {
    return design.event_seq || design.eventSeq || "";
  }

  getDownloadFileName(design, imageUrl) {
    const eventSeq = design.event_seq || design.eventSeq || design.seq || "";
    const urlWithoutQuery = String(imageUrl || "").split("?")[0];
    const extMatch = urlWithoutQuery.match(/\.([a-zA-Z0-9]+)$/);
    const ext = extMatch ? extMatch[1] : "jpg";

    return "robomd_ai_design" + (eventSeq ? "_" + eventSeq : "") + "." + ext;
  }

  downloadImageByLink(imageUrl, fileName) {
    const link = document.createElement("a");

    link.href = imageUrl;
    link.download = fileName;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  buildApplyTemplatePayload(design) {
    const imageUrl = this.getDesignImageUrl(design);
    const eventTypeCd = this.getDesignEventTypeCd(design);

    return {
      opened_from: "AI_DESIGN_STARTER",
      event_seq: design.event_seq || design.eventSeq || "",
      img_url: imageUrl || "",
      media_source_id: this.getDesignMediaSourceId(design),
      image_ratio: this.getDesignImageRatio(design),
      event_type_cd: eventTypeCd,
      upper_code_cd: design.upper_code_cd || design.upperCodeCd || getTemplateUpperCodeCdByEventTypeCd(eventTypeCd),
    };
  }

  moveToCreatePostWithDesign(design) {
    const applyPayload = this.buildApplyTemplatePayload(design);

    if (!applyPayload.img_url) {
      window.alert("등록할 이미지가 없습니다.");
      return;
    }

    sessionStorage.setItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY, JSON.stringify(applyPayload));
    window.location.href = INSTAGRAM_CREATE_POST_URL + "?apply_ai_design_template=Y";
  }

  getRecommendTemplates() {
    return this.props.recommendTemplates || this.props.recommendedTemplates || DEFAULT_RECOMMEND_TEMPLATES;
  }

  getDesignList() {
    if (Array.isArray(this.props.designList) && this.props.designList.length > 0) {
      return this.props.designList;
    }

    if (Array.isArray(this.props.myDesignList) && this.props.myDesignList.length > 0) {
      return this.props.myDesignList;
    }

    return this.state.designList || [];
  }

  getDesignImageUrl(design) {
    return design.imageUrl || design.img_url || design.source_url || design.thumbnailUrl || design.thumbnail_url || design.file_url || "";
  }

  formatDateText(dateString) {
    if (!dateString) {
      return "";
    }

    const normalized = String(dateString).replace(
      /([+-]\d{2})(\d{2})$/,
      "$1:$2"
    );
    const date = new Date(normalized);

    if (isNaN(date.getTime())) {
      return String(dateString).substring(0, 10).replace(/-/g, ".");
    }

    const now = new Date();

    const todayStart = new Date(
      now.getFullYear(),
      now.getMonth(),
      now.getDate()
    );

    const dateStart = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate()
    );

    const diffMs = now.getTime() - date.getTime();
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(
      (todayStart.getTime() - dateStart.getTime()) / (1000 * 60 * 60 * 24)
    );

    const diffMinutes = Math.floor(diffMs / (1000 * 60));

    if (diffDays === 0) {
      if (diffMinutes < 1) {
        return "방금 전";
      }

      return diffHours >= 1
        ? diffHours + "시간 전"
        : diffMinutes + "분 전";
    }

    if (diffDays === 1) {
      return "어제";
    }

    // if (diffDays > 1 && diffDays < 7) {
    //   return diffDays + "일전";
    // }

    return date.getFullYear()
      + "."
      + String(date.getMonth() + 1).padStart(2, "0")
      + "."
      + String(date.getDate()).padStart(2, "0");
  }  

  getDesignBadgeText(design) {
    return design.badgeText 
      // || design.reg_date_text 
      // || design.createdText 
      // || design.created_text 
      // || design.displayDate 
      // || design.dateText
      || this.formatDateText(design.reg_date)
      || "";
  }

  getDesignEventTypeCd(design) {
    return design.code_cd
      || design.event_type_cd
      || design.eventTypeCd
      || design.template_code_cd
      || getTemplateEventTypeCdByImageUrl(design.imageUrl || design.img_url || design.source_url || "")
      || "";
  }

  getDesignImageRatio(design) {
    const eventTypeCd = this.getDesignEventTypeCd(design);
    return design.image_ratio || design.imageRatio || design.ratio || getTemplateRatioByEventTypeCd(eventTypeCd);
  }

  handleCloseTemplateEditor() {
    this.setState({
      show_design_template_popup: false,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
      selectedDesign: null,
    }, () => this.loadEventHistory(true));
  }

  applydDesign(event_seq, img_url, media_source_id, submitInfo) {
    const selectedDesign = this.state.selectedDesign;
    const applyPayload = {
      opened_from: "AI_DESIGN_STARTER",
      event_seq: event_seq || "",
      img_url: img_url || "",
      media_source_id: media_source_id || "",
      image_ratio: this.state.currentRatio || "1/1",
      event_type_cd: this.state.selected_template_event_type_cd || "",
      upper_code_cd: this.state.selected_template_upper_code_cd || "",
      submit_info: submitInfo || {},
    };

    this.setState({
      show_design_template_popup: false,
      selected_event_seq: "",
      selected_template_event_type_cd: "",
      selected_template_upper_code_cd: "",
      selectedDesign: null,
    }, () => {
      sessionStorage.setItem(STARTER_APPLY_TEMPLATE_STORAGE_KEY, JSON.stringify(applyPayload));
      window.location.href = INSTAGRAM_CREATE_POST_URL + "?apply_ai_design_template=Y";
    });

    if (typeof this.props.onApplyDesign === "function") {
      this.props.onApplyDesign(event_seq, img_url, media_source_id, selectedDesign);
    }
  }

  renderPlusIcon(size) {
    return (
      <img
        src="https://robomd.io/static/media/default_plus.466aee97.svg"
        className="plus-icon"
        style={{ width: size || 16 }}
        alt="+"
      />
    );
  }

  renderRecommendTemplateCard(template, index) {
    return (
      <div
        className="image-card ratio-438-587"
        key={template.seq || template.id || index}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleUseTemplate(template, e)}
      >
        <div className={"card-badge mint-bg" + (template.badgeClassName ? " " + template.badgeClassName : "")}>
          {template.title || template.badgeText || "-"}
        </div>
        <img className="main-img" src={template.imageUrl || template.img_url} alt={template.alt || template.title || "추천 템플릿"} />
        <div className="hover-overlay">
          <button className="btn-overlay btn-overlay-outline" type="button" onClick={(e) => this.handleUseTemplate(template, e)}>
            템플릿 사용하기
          </button>
        </div>
      </div>
    );
  }

  renderDesignCard(design, index) {
    const imageUrl = this.getDesignImageUrl(design);
    const badgeText = this.getDesignBadgeText(design);

    return (
      <div
        className="image-card design-card"
        key={design.seq || design.id || design.design_seq || index}
        role="button"
        tabIndex={0}
        onClick={(e) => this.handleEditDesign(design, e)}
        style={{
            aspectRatio: design.image_ratio || 1,
            "--thumb-url": `url("${imageUrl}")`,
        }}
        >
        {badgeText ? (
          <div className={"card-badge" + (design.badgeClassName ? " " + design.badgeClassName : "")}>
            {badgeText}
          </div>
        ) : null}
        <button className="card-delete-button" type="button" onClick={(e) => this.handleDeleteDesign(design, e)}>
          <i className="fa fa-solid fa-trash-can"></i>
        </button>
        <img className="main-img" src={imageUrl} alt={design.title || design.name || "마이 디자인"} />
        <div className="hover-overlay">
          <button className="btn-overlay btn-overlay-navy" type="button" onClick={(e) => this.handleEditDesign(design, e)}>
            <i className="fa fa-solid fa-pen-to-square"></i> 디자인 수정
          </button>
          <button className="btn-overlay btn-overlay-mint" type="button" onClick={(e) => this.handleInstagramRegister(design, e)}>
            <i className="fa fa-brands fa-instagram"></i> 인스타 등록
          </button>
          <button className="btn-overlay btn-overlay-outline" type="button" onClick={(e) => this.handleDownloadDesign(design, e)}>
            <i className="fa fa-solid fa-download"></i> 다운로드
          </button>
        </div>
      </div>
    );
  }

  renderEmptyState() {
    return (
      <div className="empty-state-wrapper">
        <img
          src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
          alt="빈 갤러리 아이콘"
          className="empty-state-icon"
        />
        <h4 className="empty-state-title">아직 생성된 AI 디자인이 없습니다.</h4>
        <p className="empty-state-desc">상단의 버튼을 눌러 우리 브랜드에 꼭 맞는 첫 번째 디자인을 만들어보세요.</p>

        <button className="common_button hover_mint empty-create-button" type="button" onClick={this.handleCreateDesign}>
          {this.renderPlusIcon(14)} 새 디자인 만들기
        </button>
      </div>
    );
  }

  renderLoadingState() {
    return (
      <div className="empty-state-wrapper loading-state-wrapper">
        <img
          src="https://robomd.io/static/media/robo_img_icon.abed362a.svg"
          alt="디자인 목록 로딩 아이콘"
          className="empty-state-icon"
        />
        <h4 className="empty-state-title">AI 디자인 목록을 불러오는 중입니다.</h4>
        <p className="empty-state-desc">잠시만 기다려주세요.</p>
      </div>
    );
  }

  renderLoadMoreState() {
    return (
      <div className="load-more-state">
        <span className="load-more-spinner"></span>
        <span>AI 디자인을 더 불러오는 중입니다.</span>
      </div>
    );
  }

  renderTemplateEditor() {
    if (!this.state.show_design_template_popup) {
      return null;
    }

    return (
      <InstagramTemplateEditor
        onClose={this.handleCloseTemplateEditor}
        onSubmit={this.applydDesign}
        event_seq={this.state.selected_event_seq}
        event_type_cd={this.state.selected_template_event_type_cd}
        upper_code_cd={this.state.selected_template_upper_code_cd}
        ratio={convertRatioToEditorRatio(this.state.currentRatio)}
        opened_from="AI_DESIGN_STARTER"
      />
    );
  }

  toggleUnifiedSection(section) {
    const key = section === "recommend" ? "recommendExpanded" : "galleryExpanded";
    const willExpand = !this.state[key];
    this.setState({ [key]: willExpand }, () => {
      if (willExpand && section === "gallery") {
        if (typeof this.checkNeedLoadMore === "function") {
          this.checkNeedLoadMore();
        }
      } else if (!willExpand) {
        const target = section === "recommend" ? this.recommendSectionEl : this.gallerySectionEl;
        if (target && typeof target.scrollIntoView === "function") {
          target.scrollIntoView({ behavior: "smooth", block: "start" });
        }
      }
    });
  }

  renderStyle() {
    return `
      .instagram-ai-design-list.instagram-ai-design-list {
        --primary-mint: #00e2e6;
        --primary-dark: #00bfc2;
        --navy-dark: #0A1A2F;
        --bg-body: #f4f7f9;
        --bg-canvas: #ffffff;
        --text-primary: #111827;
        --text-secondary: #4b5563;
        --text-muted: #9ca3af;
        --border-color: #e5e7eb;
        --border-light: #f3f4f6;
        background-color: var(--bg-body);
        color: var(--text-primary);
        min-height: 100vh;
        width: 100%;
        overflow-x: hidden;
        font-family: 'Noto Sans KR', sans-serif;
        letter-spacing: -0.3px;
      }

      ${this.props.embedded ? "" : `#page-wrapper {
        padding: 72px 0 0 220px;
        max-width: 100%;
      }`}

      .instagram-ai-design-list.instagram-ai-design-list *,
      .instagram-ai-design-list.instagram-ai-design-list *::before,
      .instagram-ai-design-list.instagram-ai-design-list *::after {
        box-sizing: border-box;
      }

      .instagram-ai-design-list.instagram-ai-design-list button {
        font-family: inherit;
      }

      .instagram-ai-design-list .fa {
        font-family: "Font Awesome 6 Free" !important;
        font-style: normal;
        font-weight: 900;
      }

      .instagram-ai-design-list .fa-brands {
        font-family: "Font Awesome 6 Brands" !important;
        font-weight: 400;
      }

      .instagram-ai-design-list .main-content {
        display: flex;
        flex-direction: column;
        min-width: 0;
        width: 100%;
      }

      .instagram-ai-design-list .top-header {
        height: 60px;
        background-color: var(--bg-canvas);
        border-bottom: 1px solid var(--border-color);
        display: flex;
        align-items: center;
        padding: 0 32px;
        font-size: 14px;
        font-weight: 600;
        color: var(--text-primary);
      }

      .instagram-ai-design-list .top-header span {
        color: var(--text-muted);
        font-weight: 400;
        margin-right: 8px;
      }

      .instagram-ai-design-list .content-inner {
        padding: 48px 40px;
        max-width: 1600px;
        width: 100%;
        margin: 0 auto;
        display: flex;
        flex-direction: column;
        gap: 48px;
      }

      .instagram-ai-design-list .center-hero {
        text-align: center;
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 16px;
        margin-bottom: 16px;
      }

      .instagram-ai-design-list .center-hero h2 {
        font-size: 28px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .instagram-ai-design-list .center-hero p {
        font-size: 15px;
        color: var(--text-secondary);
        margin: 0 0 16px 0;
      }

      .instagram-ai-design-list .common_button.hover_mint {
        border-radius: 8px !important;
        font-weight: 700 !important;
        box-shadow: 0 4px 12px rgba(0, 226, 230, 0.2);
        transition: all 0.2s !important;
      }

      .instagram-ai-design-list .common_button.hover_mint:hover {
        background: #00D3E0 !important;
        transform: translateY(-2px) !important;
      }

      .instagram-ai-design-list .common_button.hover_mint::after {
        width: 0px !important;
        height: 0px !important;
      }

      .instagram-ai-design-list .common_button.hover_mint,
      .instagram-ai-design-list .btn-mint {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        border: none;
        background: var(--primary-mint);
        color: var(--navy-dark);
        cursor: pointer;
        padding: 14px 32px;
        font-size: 15px;
        line-height: 1;
        text-decoration: none;
      }

      .instagram-ai-design-list .plus-icon {
        filter: brightness(0);
        flex-shrink: 0;
      }

      .instagram-ai-design-list .section-header {
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 16px;
        padding-bottom: 12px;
        border-bottom: 2px solid var(--border-color);
      }

      .instagram-ai-design-list .gallery-section .section-header.empty-header {
        margin-bottom: 0;
      }

      .instagram-ai-design-list .section-title h3 {
        font-size: 18px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0;
      }

      .instagram-ai-design-list .section-count {
        font-size: 14px;
        font-weight: 600;
        color: var(--text-secondary);
      }

      .instagram-ai-design-list .section-count span {
        color: var(--primary-dark);
      }

      .instagram-ai-design-list .unified-image-grid {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
        gap: 20px;
        width: 100%;
      }

      .instagram-ai-design-list .image-card {
        position: relative;
        border-radius: 10px;
        overflow: hidden;
        background: var(--bg-canvas);
        border: 1px solid var(--border-color);
        box-shadow: 0 2px 8px rgba(10, 26, 47, 0.03);
        aspect-ratio: 4 / 5;
        cursor: pointer;
        transition: transform 0.3s ease, box-shadow 0.3s ease;
      }

      .instagram-ai-design-list .image-card.ratio-438-587 {
        aspect-ratio: 438 / 587 !important;
      }
      
      .instagram-ai-design-list .image-card.ratio-1-1 {
        aspect-ratio: 1 !important;
      }

    //   .instagram-ai-design-list .image-card img.main-img {
    //     width: 100%;
    //     height: 100%;
    //     object-fit: cover;
    //     transition: transform 0.4s ease;
    //   }

    .instagram-ai-design-list .image-card img.main-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        transition: transform 0.4s ease;
        // background: #f5f7fa;
     }

      .instagram-ai-design-list .card-badge {
        position: absolute;
        top: 10px;
        left: 10px;
        background: rgba(255, 255, 255, 0.95);
        color: var(--navy-dark);
        font-size: 11px;
        font-weight: 700;
        padding: 4px 10px;
        border-radius: 20px;
        box-shadow: 0 2px 4px rgba(0, 0, 0, 0.08);
        z-index: 10;
      }

      .instagram-ai-design-list .card-badge.mint-bg {
        background: rgba(10, 26, 47, 0.9);
        color: var(--primary-mint);
      }

      .instagram-ai-design-list .card-delete-button {
        position: absolute;
        top: 10px;
        right: 10px;
        width: 30px;
        height: 30px;
        border: none;
        border-radius: 999px;
        color: #ffffff;
        z-index: 20;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        opacity: 0;
        transform: translateY(-3px);
        transition: all 0.2s ease;
      }

      .instagram-ai-design-list .image-card:hover .card-delete-button {
        opacity: 1;
        transform: translateY(0);
      }

      .instagram-ai-design-list .card-delete-button:hover {
        border-radius: 999px;
        background: rgba(255, 255, 255, 0.1);
      }

      .instagram-ai-design-list .hover-overlay {
        position: absolute;
        inset: 0;
        background: rgba(10, 26, 47, 0.8);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        gap: 8px;
        opacity: 0;
        transition: all 0.2s ease;
        z-index: 10;
        padding: 12px;
      }

      .instagram-ai-design-list .image-card:hover {
        transform: translateY(-4px);
        box-shadow: 0 8px 16px rgba(10, 26, 47, 0.08);
        border-color: var(--primary-dark);
      }

      .instagram-ai-design-list .image-card:hover img.main-img {
        transform: scale(1.05);
      }

      .instagram-ai-design-list .image-card:hover .hover-overlay {
        opacity: 1;
      }

      .instagram-ai-design-list .image-card.design-card {
        background: #f5f7fa;
      }

      .instagram-ai-design-list .image-card.design-card::before {
        content: "";
        position: absolute;
        inset: 0;
        background-image: var(--thumb-url);
        background-size: cover;
        background-position: center;
        filter: blur(16px);
        transform: scale(1.15);
        opacity: 0.35;
        z-index: 0;
      }

      .instagram-ai-design-list .image-card.design-card img.main-img {
        position: relative;
        z-index: 1;
        object-fit: contain;
      }

      .instagram-ai-design-list .image-card.design-card .card-badge,
      .instagram-ai-design-list .image-card.design-card .hover-overlay {
        z-index: 10;
      }

      .instagram-ai-design-list .btn-overlay {
        width: 100%;
        max-width: 140px;
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 6px;
        padding: 7px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        cursor: pointer;
        transition: all 0.2s;
        border: none;
      }

      .instagram-ai-design-list .btn-overlay i {
        font-size: 13px;
      }

      .instagram-ai-design-list .btn-overlay-mint {
        background: var(--primary-mint);
        color: var(--navy-dark);
        font-weight: 700;
      }

      .instagram-ai-design-list .btn-overlay-mint:hover {
        background: var(--primary-dark);
      }

      .instagram-ai-design-list .btn-overlay-navy {
        background: #1f2937;
        color: #ffffff;
      }

      .instagram-ai-design-list .btn-overlay-navy:hover {
        background: #374151;
      }

      .instagram-ai-design-list .btn-overlay-outline {
        background: transparent;
        color: #ffffff;
        border: 1px solid rgba(255, 255, 255, 0.6);
      }

      .instagram-ai-design-list .btn-overlay-outline:hover {
        background: rgba(255, 255, 255, 0.15);
        border-color: #ffffff;
      }

      .instagram-ai-design-list .empty-state-wrapper {
        width: 100%;
        margin-top: 16px;
        background: var(--bg-canvas);
        border: 1px dashed var(--border-color);
        border-radius: 12px;
        padding: 80px 20px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        text-align: center;
      }

      .instagram-ai-design-list .empty-state-icon {
        width: 56px;
        height: 56px;
        opacity: 0.4;
        margin-bottom: 20px;
      }

      .instagram-ai-design-list .empty-state-title {
        font-size: 18px;
        font-weight: 700;
        color: var(--navy-dark);
        margin: 0 0 8px 0;
      }

      .instagram-ai-design-list .empty-state-desc {
        font-size: 14px;
        color: var(--text-secondary);
        margin: 0 0 24px 0;
      }

      .instagram-ai-design-list .empty-create-button {
        padding: 12px 24px;
        font-size: 14px;
      }

      .instagram-ai-design-list .loading-state-wrapper .empty-state-icon {
        animation: instagramAiDesignLoading 1.2s ease-in-out infinite;
      }

      .instagram-ai-design-list .load-more-state {
        display: flex;
        align-items: center;
        justify-content: center;
        gap: 8px;
        padding: 22px 0 4px;
        font-size: 13px;
        font-weight: 600;
        color: var(--text-secondary);
      }

      .instagram-ai-design-list .load-more-spinner {
        width: 16px;
        height: 16px;
        border: 2px solid rgba(0, 226, 230, 0.25);
        border-top-color: var(--primary-dark);
        border-radius: 50%;
        animation: instagramAiDesignSpin 0.8s linear infinite;
      }

      @keyframes instagramAiDesignLoading {
        0% {
          transform: translateY(0);
          opacity: 0.3;
        }
        50% {
          transform: translateY(-4px);
          opacity: 0.55;
        }
        100% {
          transform: translateY(0);
          opacity: 0.3;
        }
      }

      @keyframes instagramAiDesignSpin {
        0% {
          transform: rotate(0deg);
        }
        100% {
          transform: rotate(360deg);
        }
      }

      @media screen and (max-width: 1280px) {
        .instagram-ai-design-list .unified-image-grid {
          grid-template-columns: repeat(4, 1fr);
          gap: 16px;
        }
      }

      @media screen and (max-width: 1024px) {
        .instagram-ai-design-list .top-header {
          display: none;
        }

        .instagram-ai-design-list .content-inner {
          padding: 32px 24px;
          gap: 32px;
        }

        .instagram-ai-design-list .unified-image-grid {
          grid-template-columns: repeat(3, 1fr);
        }

        .instagram-ai-design-list .empty-state-wrapper {
          padding: 60px 20px;
        }
      }

      @media screen and (max-width: 768px) {
        .instagram-ai-design-list .center-hero h2 {
          font-size: 22px;
        }

        .instagram-ai-design-list .center-hero p {
          font-size: 13px;
          padding: 0 16px;
          word-break: keep-all;
        }

        .instagram-ai-design-list .content-inner {
          padding: 24px 16px;
          gap: 24px;
        }

        .instagram-ai-design-list .unified-image-grid {
          grid-template-columns: repeat(2, 1fr);
          gap: 12px;
        }

        .instagram-ai-design-list .card-badge {
          padding: 3px 8px;
          font-size: 10px;
        }

        .instagram-ai-design-list .btn-overlay {
          font-size: 11px;
          padding: 6px 8px;
          max-width: 100%;
        }
      }
    `;
  }

  render() {
    const recommendTemplates = this.getRecommendTemplates();
    const designList = this.getDesignList();
    const hasDesignList = designList.length > 0;
    const collapsedCount = this.props.collapsedCount || 6;
    const displayedRecommendTemplates = (this.props.embedded && !this.state.recommendExpanded) ? recommendTemplates.slice(0, collapsedCount) : recommendTemplates;
    const displayedDesignList = (this.props.embedded && !this.state.galleryExpanded) ? designList.slice(0, collapsedCount) : designList;
    const isDesignListLoading = this.state.designListLoading && !hasDesignList;
    const isDesignListMoreLoading = this.state.designListLoading && hasDesignList;
    const totalDesignCount = this.state.totalCnt || designList.length;

    const content = (
      <div className="instagram-product-automation-list instagram-ai-design-list">
            <style>{this.renderStyle()}</style>

            <main className="main-content">
            {!this.props.embedded && (
              <header className="top-header">
                <span>AI도구 &gt;</span> AI디자인
              </header>
            )}

            <div className="content-inner">
                {!this.props.embedded && (
                  <section className="center-hero">
                    <h2>AI 디자인</h2>
                    <p>상품 사진과 텍스트를 결합하여 트렌디한 배너와 홍보용 디자인을 쉽고 빠르게 제작해보세요.</p>
                    <button className="common_button hover_mint" type="button" onClick={this.handleCreateDesign}>
                      {this.renderPlusIcon(16)} 새 디자인 만들기
                    </button>
                  </section>
                )}

                <section className="recommend-section" ref={(el) => { this.recommendSectionEl = el; }}>
                {this.props.embedded ? (
                  <StudioSectionHeader title="템플릿 디자인 스타일 갤러리" totalCount={recommendTemplates.length}
                    buttonText="모든 템플릿 보기" expanded={this.state.recommendExpanded} canToggle={recommendTemplates.length > collapsedCount}
                    onToggle={() => this.toggleUnifiedSection("recommend")} />
                ) : (
                  <div className="section-header"><div className="section-title"><h3>로보MD 추천 디자인 템플릿</h3></div></div>
                )}

                <div className="unified-image-grid">
                    {displayedRecommendTemplates.map((template, index) => this.renderRecommendTemplateCard(template, index))}

                </div>
                {this.props.embedded ? <StudioFoldControl expanded={this.state.recommendExpanded && recommendTemplates.length > collapsedCount} label="접기" onToggle={() => this.toggleUnifiedSection("recommend")} /> : null}
                </section>

                <section className="gallery-section" ref={(el) => { this.gallerySectionEl = el; }}>
                {this.props.embedded ? (
                  <StudioSectionHeader title="마이 갤러리" totalCount={totalDesignCount}
                    buttonText="모든 작업물 보기" expanded={this.state.galleryExpanded}
                    canToggle={designList.length > collapsedCount || totalDesignCount > collapsedCount}
                    onToggle={() => this.toggleUnifiedSection("gallery")} />
                ) : (
                  <div className={"section-header" + (!hasDesignList ? " empty-header" : "")}>
                    <div className="section-title"><h3>마이 디자인 갤러리</h3></div>
                    {hasDesignList ? <div className="section-count">총 <span>{totalDesignCount}</span>개의 디자인</div> : null}
                  </div>
                )}

                {isDesignListLoading ? (
                    this.renderLoadingState()
                ) : hasDesignList ? (
                  <>
                    <div className="unified-image-grid">
                      {displayedDesignList.map((design, index) => this.renderDesignCard(design, index))}
                    </div>
                    {isDesignListMoreLoading && (!this.props.embedded || this.state.galleryExpanded) ? this.renderLoadMoreState() : null}
                    {this.props.embedded ? <StudioFoldControl expanded={this.state.galleryExpanded} label="작업물 접기" onToggle={() => this.toggleUnifiedSection("gallery")} /> : null}
                  </>
                ) : (
                    this.renderEmptyState()
                )}
                </section>
            </div>
            </main>
            {this.renderTemplateEditor()}
            {this.state.isSizeModalOpen && (
              <ModalSizeSelect
                isOpen={this.state.isSizeModalOpen}
                onClose={() => {
                  this.setState({ isSizeModalOpen: false });
                }}
                onSelect={this.openNewDesignEditorByRatio}
              />
            )}
      </div>
    );

    // 기존 관리자 레이아웃은 독립 페이지에서만 사용합니다.
    // 통합 페이지(embedded=true)에는 page-wrapper DOM 자체를 생성하지 않습니다.
    return this.props.embedded ? content : (
      <div id="page-wrapper" className="instagram-product-automation-list">
        {content}
      </div>
    );
  }
}

export default InstagramAiDesignList;